<script>
import { movementService } from '../../../helpers/backend/movement.service'
/**
 * Transactions component
 */
export default {
  data() {
    return {
      data: [],
      filter_type: "",
      loading: false,
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50],
      filter: null,
      filterOn: [],
      sortBy: "id",
      sortDesc: false,
      fields: [
        { key: "id", sortable: true, label: "Movement ID" },
        { key: "work_id", sortable: true, label: "Work ID" },
        { key: "from_inventory.product.sku", sortable: true, label: "Product SKU" },
        { key: "from_inventory.product.name", sortable: true, label: "Product Name" },
        { key: "from", sortable: true, label: "From" },
        { key: "to", sortable: true, label: "To" },
        { key: "quantity", sortable: true, label: "Quantity" },
      ],
      showDismissibleAlert: false,
      active: true,
    }
  },
  computed: {
    /**
     * Total no. of records
     */
    rows() {
      return this.data.length
    }
  },
  created() {
    this.fetchData()
  },
  mounted() {
    // Set the initial number of items
    this.totalRows = this.data.length
  },
  methods: {
    /**
     * Search the table data with search input
     */
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },
    setActive(b) {
      this.active = b
    },
    refreshList() {
      movementService.getAll().then(
        data => {
          this.data = data.movements
          this.loading = false
        },
        err => {
          this.error = "Failed to fetch movement type data. Error : " + err + "  Dissmiss to refresh"
          this.loading = false
          this.showDismissibleAlert = true
        }
      )
    },
    fetchData() {
      this.error = null
      this.loading = true
      this.showDismissibleAlert = false
      this.refreshList()

    },
    // onDelete(id) {
    //   if(confirm("Do you really want to delete this instance, this action can't be undone?")){
    //     advertisementService.deleteAdvertismenetTypeById(id).then(
    //       data => {
    //         this.fetchData()
    //         console.log(data)
    //       },
    //       err => {
    //         this.error = "Failed to delete advertisement. Error : " + err;
    //         this.showDismissibleAlert=true
    //       }
    //     )
    //   }
    // },
    // onUpdate(id) {
    //   this.$emit('onEdit',id);
    // }
  }
};
</script>
<template>
  <div v-if="this.active">
    <b-alert
      variant="danger"
      dismissible
      fade
      :show="showDismissibleAlert"
      @dismissed="fetchData"
    >
      {{ error }}
    </b-alert>
    <div class="card">
      <div class="card-body">
        <!-- <b-dropdown right toggle-class="arrow-none card-drop" class="float-right" variant="white">
        <template v-slot:button-content>
          <i class="mdi mdi-dots-vertical"></i>
        </template>
        <b-dropdown-item>Sales Report</b-dropdown-item>
        <b-dropdown-item>Export Report</b-dropdown-item>
        <b-dropdown-item>Profit</b-dropdown-item>
        <b-dropdown-item>Action</b-dropdown-item>
      </b-dropdown> -->

        <!-- <h4 class="card-title mb-4">(.*)</h4> -->
        <div class="row mt-4">
          <div class="col-sm-12 col-md-4">
            <div id="tickets-table_length" class="dataTables_length">
              <label class="d-inline-flex align-items-center">
                Show&nbsp;
                <b-form-select
                  v-model="perPage"
                  size="sm"
                  :options="pageOptions"
                ></b-form-select
                >&nbsp;entries
              </label>
            </div>
          </div>

          <!-- Search -->
          <div class="col-sm-12 col-md-4">
            <div
              id="tickets-table_filter"
              class="dataTables_filter text-md-right"
            >
              <label class="d-inline-flex align-items-center">
                Search:
                <b-form-input
                  v-model="filter"
                  type="search"
                  class="form-control form-control-sm ml-2"
                ></b-form-input>
              </label>
            </div>
          </div>
          <!-- End search -->
        </div>
        <div class="table-responsive">
          <b-table
            :items="data"
            :fields="fields"
            responsive="sm"
            :per-page="perPage"
            :current-page="currentPage"
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            :filter="filter"
            :filter-included-fields="filterOn"
            @filtered="onFiltered"
          >
            <template v-slot:cell(from)="item">
              <!-- {{ item }} -->
              {{
                item.item.from_inventory.location.machine_id.Valid
                  ? item.item.from_inventory.location.machine.serial_number
                  : ""
              }}
              {{
                item.item.from_inventory.location.warehouse_id.Valid
                  ? item.item.from_inventory.location.warehouse.name
                  : ""
              }}
              {{
                item.item.from_inventory.location.vehicle_id.Valid
                  ? item.item.from_inventory.location.vehicle.name +
                    "(" +
                    item.item.from_inventory.location.vehicle.vehicle_number +
                    ")"
                  : ""
              }}
              <div class="badge font-size-12 badge-soft-success">
                {{
                  item.item.from_inventory.location.machine_id.Valid
                    ? "Machine"
                    : ""
                }}
                {{
                  item.item.from_inventory.location.warehouse_id.Valid
                    ? "Warehouse"
                    : ""
                }}
                {{
                  item.item.from_inventory.location.vehicle_id.Valid
                    ? "Vehicle"
                    : ""
                }}
              </div>
            </template>
            <template v-slot:cell(to)="item">
              {{
                item.item.to_inventory.location.machine_id.Valid
                  ? item.item.to_inventory.location.machine.serial_number
                  : ""
              }}
              {{
                item.item.to_inventory.location.warehouse_id.Valid
                  ? item.item.to_inventory.location.warehouse.name
                  : ""
              }}
              {{
                item.item.to_inventory.location.vehicle_id.Valid
                  ? item.item.to_inventory.location.vehicle.name +
                    "(" +
                    item.item.to_inventory.location.vehicle.vehicle_number +
                    ")"
                  : ""
              }}
              <div class="badge font-size-12 badge-soft-success">
                {{
                  item.item.to_inventory.location.machine_id.Valid
                    ? "Machine"
                    : ""
                }}
                {{
                  item.item.to_inventory.location.warehouse_id.Valid
                    ? "Warehouse"
                    : ""
                }}
                {{
                  item.item.to_inventory.location.vehicle_id.Valid
                    ? "Vehicle"
                    : ""
                }}
              </div>
            </template>
          </b-table>
        </div>
        <div class="row">
          <div class="col">
            <div class="dataTables_paginate paging_simple_numbers float-right">
              <ul class="pagination pagination-rounded mb-0">
                <!-- pagination -->
                <b-pagination
                  v-model="currentPage"
                  :total-rows="rows"
                  :per-page="perPage"
                ></b-pagination>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>